import Button from "@mui/material/Button";

const NitroLargeIcon = ({
  label,
  icon,
  onClick,
  variant = "contained",
  disabled,
  editComponent,
}: {
  label: string;
  icon: React.ReactElement;
  onClick: () => void;
  variant: "contained" | "outlined";
  disabled?: boolean;
  editComponent?: React.ReactElement | React.ReactNode;
}) => {
  return (
    <div className="popupLargeButton" style={{ display: "flex" }}>
      <Button
        disabled={disabled}
        variant={variant}
        fullWidth
        onClick={onClick}
        style={{
          backgroundColor: variant === "contained" ? "#005CA6" : "white",
          height: 50,
          opacity: disabled ? 0.5 : 1,
          borderTopRightRadius: editComponent ? 0 : undefined,
          borderBottomRightRadius: editComponent ? 0 : undefined,
        }}
      >
        <div
          style={{
            width: "100%",
            position: "relative",
          }}
        >
          <div className="popupLargeButtonIcon">{icon}</div>
          <div className="popupLargeButtonLabel">{label}</div>
          <div />
        </div>
      </Button>
      {editComponent}
    </div>
  );
};

export default NitroLargeIcon;
